import classes from "./Footer.module.scss";

function Footer() {
  return (
    <footer className={classes.footer}>
        <p>
          © 2026 おおくま一輪車クラブ. All rights reserved.
        </p>
    </footer>
  );
}

export default Footer;
